import './App.css'
import GameContainer from './Game/GameContainer'
import { gamesCachedValue } from './Game/GameDataModel'

function App() {
  return (
    <div className="App">
      <GameContainer game={gamesCachedValue[0]} />
    </div>
  )
}

export default App
